module.exports = __webpack_public_path__ + "static/media/proj1_img4.3040383d.jpg";